var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4275)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_4275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7214 37.4993C32.3118 39.25 28.8745 39.25 22 39.25C15.1255 39.25 11.6882 39.25 9.27863 37.4993C8.50043 36.9339 7.81607 36.2496 7.25068 35.4714C5.5 33.0618 5.5 29.6245 5.5 22.75C5.5 15.8755 5.5 12.4382 7.25067 10.0286C7.81607 9.25044 8.50043 8.56607 9.27863 8.00068C11.6882 6.25 15.1255 6.25 22 6.25C28.8745 6.25 32.3118 6.25 34.7214 8.00068C35.4996 8.56607 36.1839 9.25043 36.7493 10.0286C38.5 12.4382 38.5 15.8755 38.5 22.75C38.5 29.6245 38.5 33.0618 36.7493 35.4714C36.1839 36.2496 35.4996 36.9339 34.7214 37.4993Z",
    fill: "url(#paint0_linear_1_4275)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7214 37.4993C32.3118 39.25 28.8745 39.25 22 39.25C15.1255 39.25 11.6882 39.25 9.27863 37.4993C8.50043 36.9339 7.81607 36.2496 7.25068 35.4714C5.5 33.0618 5.5 29.6245 5.5 22.75C5.5 15.8755 5.5 12.4382 7.25067 10.0286C7.81607 9.25044 8.50043 8.56607 9.27863 8.00068C11.6882 6.25 15.1255 6.25 22 6.25C28.8745 6.25 32.3118 6.25 34.7214 8.00068C35.4996 8.56607 36.1839 9.25043 36.7493 10.0286C38.5 12.4382 38.5 15.8755 38.5 22.75C38.5 29.6245 38.5 33.0618 36.7493 35.4714C36.1839 36.2496 35.4996 36.9339 34.7214 37.4993Z",
    stroke: "url(#paint1_linear_1_4275)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_4275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6988 12.6067C25.2382 12.0721 26.1088 12.076 26.6433 12.6154C27.1779 13.1547 27.174 14.0253 26.6347 14.5599L23.4026 17.7633C22.0908 19.0634 21.191 19.9581 20.5822 20.7163C19.9907 21.4527 19.7878 21.9257 19.7338 22.3494C19.6999 22.6154 19.6999 22.8845 19.7338 23.1506C19.7878 23.5742 19.9907 24.0472 20.5822 24.7837C21.191 25.5418 22.0908 26.4365 23.4026 27.7366L26.6347 30.94C27.174 31.4746 27.1779 32.3452 26.6433 32.8846C26.1088 33.4239 25.2382 33.4278 24.6988 32.8932L21.4085 29.6321C20.1692 28.4039 19.1563 27.4 18.438 26.5056C17.6911 25.5755 17.1504 24.6315 17.0059 23.4983C16.9426 23.0014 16.9426 22.4985 17.0059 22.0017C17.1504 20.8685 17.6911 19.9244 18.438 18.9943C19.1563 18.0999 20.1692 17.096 21.4085 15.8678L24.6988 12.6067Z",
    fill: "url(#paint2_linear_1_4275)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_4275",
    x: -19,
    y: -18.25,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_4275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_4275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_4275",
    x: 13.9585,
    y: 9.20825,
    width: 26.0833,
    height: 37.0834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4275",
    x1: 38.5,
    y1: 39.25,
    x2: 5.51674,
    y2: 6.23328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4275",
    x1: 38.5,
    y1: 39.25,
    x2: 5.51674,
    y2: 6.23328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_4275",
    x1: 14.8102,
    y1: 22.5724,
    x2: 37.2963,
    y2: 11.6015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackSquare);
export default __webpack_public_path__ + "static/media/back-square.23121766efe934af367272b700d155fb.svg";
export { ForwardRef as ReactComponent };